import React, { useEffect, useRef, useState } from 'react'
import { Label, Error } from "@progress/kendo-react-labels";
import parse from 'html-react-parser'
import { Input, RadioButton, RadioGroup, RadioGroupHandle } from '@progress/kendo-react-inputs'
import { SurveyEngine_Models_BaseResponse, SurveyEngine_Models_GetResponseResponse, SurveyEngine_Models_WebLayout } from '../../../api'
// import { languageResources } from '../../../Utils/messages';
// import { validationError } from '../../../Common';
import { ComboBox, DropDownList } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { GetResponseAnswerData } from '../../../Common/Commands';
import { useGlobalCtx } from '../../../Context/GlobalContext';
import useCheckMobileScreen from '../../../Hooks/useCheckMobileScreen';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleExclamation} from '@fortawesome/pro-regular-svg-icons';

interface GetResponseProps {
  id: number,
  question: string,
  answers: GetResponseAnswerData[],
  defaultAnswer: string,
  layout: string,
  columns?: number,
  isError: boolean,
  focus: boolean
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}

export const GetResponse = (props: GetResponseProps) => {
  const [isOpenEndedID, setIsOpenEndedID] = useState<number>(-99)
  const [otherValue, setOtherValue] = useState("")
  const [isError, setIsError] = useState(props.isError)
  const [value, setValue] = useState(props.defaultAnswer);
  const [answerData,setAnswerData] = useState(props.answers)
  let touched = useRef<boolean>(false);
  const answercomboBoxRef = useRef<ComboBox | null>(null)
  const answerButtonRef = useRef<Button>(null)
  const globalCTX = useGlobalCtx()
  const {isMobile} = useCheckMobileScreen()
  const cols: number = props.columns !== undefined ? props.columns : 1 ;
  const displayCols: number = cols > 5 ? 5 : cols;
  const selectedRadioRef = useRef<HTMLInputElement | null>(null);
  let rbCheckChanged = useRef<boolean>(false);
  const otherInputRef = (node: HTMLInputElement) => {
    if (node && props.focus) {
      node.focus();
      selectedRadioRef.current = null;
    }
  }
  const labelId = `${props.id}_label`
  const errorId = `${props.id}_error`
  const otherInputId = `${props.id}_other_input`
  
  useEffect(() => {
    setValue(props.defaultAnswer);
    setAnswerData(props.answers);
    //if we have default value we must add the the user response for default as well.
    if (props.defaultAnswer !== "") {
      let response: SurveyEngine_Models_GetResponseResponse;
      let defaultSelectedAns = props.answers.find(a => a.value.toString() === props.defaultAnswer);
      if (defaultSelectedAns?.isOpenEnded) {
        setIsOpenEndedID(defaultSelectedAns.value);
        setOtherValue(defaultSelectedAns.otherValue ?? "")
        response = {
          commandType: "GetResponse",
          commandIndex: props.id,
          selectedId: parseInt(props.defaultAnswer),
          otherValue: defaultSelectedAns.otherValue ?? ""
        };
        setIsError(props.isError)
      }
      else {
        response = {
          commandType: "GetResponse",
          commandIndex: props.id,
          selectedId: parseInt(props.defaultAnswer),
        };
      }
      props.callback(response);
    }
    else {
      setIsError(props.isError)
    }
  }, [props])
  
  useEffect(() => {
    if (props.focus) {
      if (props.layout === SurveyEngine_Models_WebLayout.DROPDOWN)
        answercomboBoxRef.current?.focus()
      else if (props.layout === SurveyEngine_Models_WebLayout.SELECTION_BOXES) {
        answerButtonRef.current?.element?.focus()
      } 
      else {
        if (selectedRadioRef.current) {
          selectedRadioRef.current.focus()
        }
      }
    }
  }, [props])

  useEffect(() => {
    // Set focus to the selected radio button when the component re-renders
    if (selectedRadioRef.current) {
      const selectedRadioVal = selectedRadioRef.current.value;
      const isOpenEnded= props.answers.find(item => item.isOpenEnded && item.value.toString() === selectedRadioVal && item.otherValue !== '');
      if(isOpenEnded){
        document.getElementById(otherInputId)?.focus();
      }
      else{
        selectedRadioRef.current.focus();
      }
    }
  }, [value]);

  function clearCurrentResponse() {
    setValue('');
    let response: SurveyEngine_Models_GetResponseResponse = {
      commandType: "Remove",
      commandIndex: props.id,
      selectedId: -1
    };
    setIsError(true);
    props.callback(response);
  }

  const handleCustomAnswer = (e: any) => {
    setIsError(false);

    if (!touched.current)
      touched.current = true;

    let response: SurveyEngine_Models_GetResponseResponse = {
      commandType: "GetResponse",
      commandIndex: props.id,
      selectedId: isOpenEndedID,
      otherValue: e.value
    };
    props.callback(response);
    setOtherValue(e.value);
  }
  const handleDropDownChange = (e: any) => {
    if (e.value) {
      setValue(e.value.value);
      let selectedAnswer = props.answers.find(a => a.value === e.value.value)
      if (!selectedAnswer) {
        clearCurrentResponse();
      }
      else {
        if (selectedAnswer?.isOpenEnded) {
          setIsOpenEndedID(selectedAnswer.value);
        }
        else {
          if (isOpenEndedID !== -99)
            setIsOpenEndedID(-99);
        }
        let response: SurveyEngine_Models_GetResponseResponse = {
          commandType: "GetResponse",
          commandIndex: props.id,
          selectedId: e.value?.value
        };
        setIsError(false);
        props.callback(response);
      }
    }
    else {
      clearCurrentResponse();
    }
  }
  const handleGetResponseChange = (e: any) => {
    //Need to explocitly check undefined as e.value can also be 0
    if (e?.value !== undefined) {
      setValue(e.value);
      let selectedAnswer = props.answers.find(a => a.value === e.value)
      if (!selectedAnswer) {
        clearCurrentResponse();
      }
      else {
        if (selectedAnswer?.isOpenEnded) {
          setIsOpenEndedID(selectedAnswer.value);
        }
        else {
          if (isOpenEndedID !== -99)
            setIsOpenEndedID(-99);
        }
        let response: SurveyEngine_Models_GetResponseResponse = {
          commandType: "GetResponse",
          commandIndex: props.id,
          selectedId: e.value
        };
        setIsError(false);
        props.callback(response);
      }
      if (!rbCheckChanged.current){
        rbCheckChanged.current = true;
      }
    }
    else {
      clearCurrentResponse();
    }
  }
  const selectionboxInput = () => {
    return (answerData as Array<any>).map((item: any, index) => {
      if ((props.defaultAnswer === "" && index === 0)) {
        return (
          <Button
            // className="theme-btn-select-box font-bold"
            ref={answerButtonRef}
            aria-describedby={labelId}
            key={`Selection_${item.value}`}
            onClick={() => handleGetResponseChange({ label: item.label, value: item.value })}
            selected={false}
            togglable={value.toString() === item.value.toString()}
            id={`Selection_${item.value}`}
            // themeColor={value.toString() === item.value.toString() ? 'primary' : 'secondary'}
            className={value.toString() === item.value.toString() ? 'theme-btn-select-box theme-btn-select-box-selected font-bold' : 'theme-btn-select-box font-bold'}

          >
            {parse(item.label.replace(/""/g,'"'))}
            
          </Button>
        )
      }

      else if ((props.defaultAnswer !== "" && props.defaultAnswer.toString() === item.value.toString())) {
        return (
          <Button
            // className="theme-btn-select-box font-bold"
            ref={answerButtonRef}
            aria-describedby={labelId}
            key={`Selection_${item.value}`}
            onClick={() => handleGetResponseChange({ label: item.label, value: item.value })}
            togglable={value.toString() === item.value.toString()}
            selected={false}
            id={`Selection_${item.value}`}
            className={value.toString() === item.value.toString() ? 'theme-btn-select-box theme-btn-select-box-selected font-bold' : 'theme-btn-select-box font-bold'}
          >
            {parse(item.label.replace(/""/g,'"'))}
          </Button>
        )
      }
      else {
        return (
          <Button
            // className="theme-btn-select-box font-bold"
            aria-describedby={labelId}
            key={`Selection_${item.value}`}
            onClick={() => handleGetResponseChange({ label: item.label, value: item.value })}
            togglable={value.toString() === item.value.toString()}
            selected={false}
            id={`Selection_${item.value}`}
            // themeColor={value.toString() === item.value.toString() ? 'primary' : 'secondary'}
            className={value.toString() === item.value.toString() ? 'theme-btn-select-box theme-btn-select-box-selected font-bold' : 'theme-btn-select-box font-bold'}

          >
            {parse(item.label.replace(/""/g,'"'))}
          </Button>

        )
      }
    }
    )
  }
  const RadioItemCustom: React.ComponentType<React.HTMLAttributes<HTMLLIElement>> = (liProps) => {
    if (React.isValidElement(liProps.children)) {
      const parsedData = parse(liProps.children.props.label.replace(/""/g,'"'))
      if (typeof parsedData === 'string') {
        const newProps = {...liProps.children.props, label: parse(liProps.children.props.label) };
        return (
          <li {...liProps}>
            <RadioButton {...newProps}
              ref={(el) => {
                if ((value === '' && newProps.index === 0) || (parseInt(value) === parseInt(newProps.value))) {
                  if (props.focus || rbCheckChanged?.current) {
                    selectedRadioRef.current = el ? el.element : null;
                  }
                }
              }}
            />
          </li>
        )
      } 
      else {
        var { label, ...newProps } = liProps.children.props;
        return (
          <li {...liProps}>
            {
              <RadioButton {...newProps}
                ref={(el) => {
                  if ((value === '' && newProps.index === 0) || (parseInt(value) === parseInt(newProps.value))) {
                    if (props.focus || rbCheckChanged?.current) {
                      selectedRadioRef.current = el ? el.element : null;
                    }
                  }
                }}
              >
                <label
                  className={'k-radio-label'}
                  htmlFor={`:rb${newProps.index}:`}
                  aria-label={getText(liProps.children.props.label)}
                  style={{ userSelect: 'none' }}
                >
                  {parsedData}
                </label>
              </RadioButton>
            }
          </li>
        )
      }
    } else {
      return <li {...liProps}></li>
    }
  }
  function getText(html: string) {
    var divContainer = document.createElement('div')
    divContainer.innerHTML = html
    return divContainer.textContent || divContainer.innerText || ''
  }

  return (
    <div className="theme-get-response mb-3 w-full" data-testid={`getresponse-${props.id}`}>

        {/* we need to add a 'for' to the descriptor of this label */}
        <Label
          className="theme-question text-xl font-semibold w-full block"
          data-testid={labelId}
          id={labelId}
          editorId={props.id.toString()}
        >
          {parse(props.question.replace(/""/g,'"'))}
        </Label>

      <div className="theme-answer w-full block">
        {
          props.layout === SurveyEngine_Models_WebLayout.DROPDOWN &&

          <DropDownList
            ref={answercomboBoxRef}
            ariaLabelledBy={labelId}
            ariaDescribedBy={errorId}
            data={answerData.map(item =>({...item,  label: getText(item.label)}))}
            textField="label"
            dataItemKey='value'
            value={answerData.map(item =>({...item,  label: getText(item.label)})).find(a => a.value === parseInt(value)) || { label: globalCTX.LangResources.getResponseMsg.placeholder }}
            defaultItem={{ label: globalCTX.LangResources.getResponseMsg.placeholder }}
            onChange={handleDropDownChange}
            className="theme-dropdown-list"
          />

        }
        {isMobile ?
        // This is the Mobile layout
          <div className='pt-0 flex flex-col space-y-4'>
            {answerData && props.layout === SurveyEngine_Models_WebLayout.SELECTION_BOXES &&
              selectionboxInput()
            }
          </div> :
          // This is the Web Layout
          <div className={'pt-0 gap-y-2.5 gap-x-4 grid grid-cols-'+ displayCols}>
            {answerData && props.layout === SurveyEngine_Models_WebLayout.SELECTION_BOXES &&
               selectionboxInput()
            }
          </div>
        }
        {(props.layout === SurveyEngine_Models_WebLayout.HORIZONTAL || props.layout === SurveyEngine_Models_WebLayout.VERTICAL) &&
          (<RadioGroup
            className="theme-select-item"
            name={props.id.toString()}
            ariaLabelledBy={labelId}
            ariaDescribedBy={errorId}
            layout={props.layout === SurveyEngine_Models_WebLayout.HORIZONTAL ? 'horizontal' : 'vertical'}
            data={answerData.map((item) => {
              return {
                label: item.label as string,
                value: item.value
              }
            })}
            valid={true}
            value={value === "" ? null : parseInt(value)}
            onChange={handleGetResponseChange}
            item={RadioItemCustom}
          />)
        }
        {isOpenEndedID !== -99 && (
          <Input 
            id={otherInputId}
            className="theme-custom-answer text-base font-semibold"
            ref={otherInputRef}
            placeholder={globalCTX.LangResources.getResponseMsg.otherPlaceHolder}
            onChange={handleCustomAnswer}
            value={otherValue}
          />
        )}
        {(isError || (isOpenEndedID !== -99 && !otherValue && touched?.current)) && <Error id={errorId} className="theme-validator-error-text font-semibold" direction='start' ><FontAwesomeIcon icon={faCircleExclamation} className="theme-icon-spacer" />{isOpenEndedID !== -99 ? globalCTX.LangResources.getResponseMsg.otherErrorMsg : globalCTX.LangResources.getResponseMsg.noResponseErrorMsg}</Error>}
      </div>
    </div>

  )
}
